import { Col, RadioButton, Row } from 'plataforma-fundacao-componentes';
import { useMemo } from 'react';
import styles from './RadioSelector.scss';
const { rootClassName } = styles;

type RadioSelectorOption = {
  label: string;
  value: string;
};
interface RadioSelectorProps {
  setValue: (value: any) => void;
  value: any;
  options: RadioSelectorOption[];
  label: string;
}
export default function RadioSelector(props: RadioSelectorProps) {
  const options = useMemo(() => {
    return props.options.map((opt, i) => {
      return (
        <Col key={i} className={`${rootClassName}-option`}>
          <RadioButton
            type='button'
            onChange={() => {
              props.setValue(opt.value);
            }}
            value={props.value === opt.value}
          />
          <button
            type='button'
            className={`${rootClassName}-label nunito`}
            onClick={() => {
              props.setValue(opt.value);
            }}
          >
            {opt.label}
          </button>
        </Col>
      );
    });
  }, [props]);

  return (
    <Row className={rootClassName}>
      <Col className={`${rootClassName}-title nunito`}>{props.label}</Col>
      {options}
    </Row>
  );
}
